export default "__VITE_ASSET__Ctlf39$a__"